<template>
  <div
    id="app-content"
    :class="`${onlyPhoneBar?'only':''}`"
    :style="{ minWidth: _config.MIN_WIDTH + 'px' }"
    v-loading="loadingFlag"
    element-loading-text="Loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(105, 197, 255, 0.9)"
  >
    <router-view v-if="!loadingFlag" />
    <!-- 提前认证：部分签入页面需要提前认证 -->
    <template v-for="(src, key) in getIframeLogin">
      <iframe :id="key" :key="key" :src="src" v-show="false"></iframe>
    </template>
    <el-image
      ref="viewImg"
      style="display: none"
      :src="url"
      :preview-src-list="srcList"
    >
    </el-image>
    <radish-go-poc
      :visible="radishGoPocVisible"
      @close="radishGoPocVisible=false"
    />
  </div>
</template>

<script>
import {
  getUserInfo,
  getOtherSystemConfig,
  getUserConfig,
  getPopTabNameConfig,
  getRadishGoPocDeptId
} from "@/api/index.js";
import { mapActions, mapGetters } from "vuex";
import Push from "push.js";
import Cookie from "js-cookie";
import * as ReconnectingWebSocket from "@/assets/js/reconnecting-websocket.js";
import { initWinCallSdk } from "@/assets/js/wincall-init/index.js";
import ShineObj from "@/assets/js/shineTitle.js";
import wsMsgMixin from "@/mixins/wsMsg";
import postMsgMixin from "@/mixins/postMsg";
import { loadScript, getValByPath } from "@/utils/index";
import RadishGoPoc from '@/components/radishGoPoc'
import { Watermark } from 'watermark-js-plus'
import Config from '@/constant/index'

const getContentByLang = (content, lang) => {
  let result = ''
  try {
    const contentObj = JSON.parse(content)

    if(lang.startsWith('zh')){
      result = contentObj.zh
    } else if(lang.startsWith('en')) {
      result = contentObj.en
    }
  } catch (error) {
    result = content
  }

  return result
}

export default {
  name: "app",
  mixins: [wsMsgMixin, postMsgMixin],
  components: { RadishGoPoc },
  data() {
    return {
      loadingFlag: true,
      _visibilityState: false,
      msgSocket: null,
      heart_monitor_timer: null,

      url: "",
      srcList: [],
      radishGoPocVisible: false, // 萝卜快跑poc
      watermark: null // 水印
    };
  },
  computed: {
    ...mapGetters(["userInfo", "activeTabKey"]),
    getIframeLogin() {
      const { iframeCookieLogin = {} } = this.userInfo || {};
      // 企点phone-bar路由不需要这些断点登录
      if(location.hash.includes('phone-bar')){
        return []
      }
      // 企点座席端过滤掉云问
      if(iframeCookieLogin && location.hash.includes('qidian/agent')){
        const ret = {}
        for(let key in iframeCookieLogin) {
          if(key !== 'yuwen') {
            ret[key] = iframeCookieLogin[key]
          }
        }
        return ret
      }
      return iframeCookieLogin;
    },

    onlyPhoneBar(){
      if(location.hash.includes('qidian/phone-bar')){
        return true
      }
      return false
    }
  },
  mounted() {
    this.queryBaseInfo();
    Push.Permission.request(()=>{},()=>{})
  },
  beforeDestroy() {
    this.msgSocket && this.msgSocket.close();
    if(this.watermark) {
      this.watermark.destroy()
    }
  },
  methods: {
    ...mapActions([
      "changeUserInfo",
      "addTab",
      "delTab",
      "changeDialogInfo",
      "changeDrawerInfo",
      'setOtherSystemConfig'
    ]),
    // 1、获取用户信息及配置
    queryBaseInfo() {
      Promise.all([getUserInfo(), getUserConfig(), getOtherSystemConfig()])
        .then(async ([userInfo, config, otherSystemConfig]) => {
          // 如果有跳转的redirect-url，则跳转
          const redirectUrlKey = Config.REDIRECT_URL
          const redirectUrl = sessionStorage.getItem(redirectUrlKey)
          if(redirectUrl) {
            sessionStorage.removeItem(redirectUrlKey)
            window.location.href = redirectUrl
          }

          if (config.code == 0) {
            this._config.URL = config.data;
            this._Bus.$emit("updateAppConfig");

            let pop_address = getValByPath(
              config.data,
              ["my", "pop_address"],
              null
            );
            let baidu_statistics = getValByPath(
              config.data,
              ["my", "baidu_statistics"],
              null
            );

            this._config.POP_ADDRESS = pop_address;

            // 百度统计资源
            if (baidu_statistics) {
              let hm = document.createElement("script");
              hm.src = baidu_statistics;
              let s = document.getElementsByTagName("script")[0];
              s.parentNode.insertBefore(hm, s);
            }
          }

          if(otherSystemConfig.code === 0) {
            this.setOtherSystemConfig(otherSystemConfig.data || {})
          }

          if (userInfo.code === 0) {
            Cookie.set("vcc_code", userInfo.data.vccCode);
            Cookie.set("agent_num", userInfo.data.userNum);
            this.changeUserInfo(userInfo.data);
            this.$nextTick(() => {
              this.setAppNotifyPostion();
              this.setSysBaseInfo();
              // 企点座席端或客户端嵌入不初始化电话条
              if(location.hash.includes('qidian/admin') || location.hash.includes('qidian/agent')) {
                console.log(this.$t('app.qidianNoPhoneBar'));
              } else {
                this.initWincall();
              }

              this.initMsgSocket();
              this.loadMatomo();
              // 如果开启水印功能
              if(userInfo.data.vcc && userInfo.data.vcc.ifWatermark) {
                this.loadWatermark()
              }
              this._Bus.$emit("updateUserInfo");
            });
            this.loadingFlag = false;

            // 萝卜快跑poc
            if(userInfo.data.vccCode === '6024102202' || userInfo.data.vccCode === 'wuhan') {
              getRadishGoPocDeptId().then(res => {
                console.log('t', res, userInfo);
                if(res.code === 0 && res.data.deptId === userInfo.data.deptId) {
                  this.radishGoPocVisible = true
                }
              })
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.loadingFlag = false;
        });
    },
    loadMatomo() {
      console.log('loadMatomo')
      let { vccId = '', userId = '', vccCode = '', userNum = ''} = this.userInfo || {}
      vccId = vccId + ''
      userId = userId + ''
      let matomoHost = 'matomo.ctiplus.com'
      let visitorId = ''
      if(/-test|localhost/.test(location.href)){
        matomoHost = 'matomo-test.ctiplus.com'
      }
      if(vccId && userId){
        visitorId = vccId.padEnd(16-userId.length,'A') + userId
      }

      var _paq = (window._paq = window._paq || []);
      /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
      _paq.push(["trackPageView"]);
      _paq.push(["enableLinkTracking"]);
      (function () {
        var u = `//${matomoHost}/`;
        _paq.push(["setTrackerUrl", u + "matomo.php"]);
        _paq.push(["setSiteId", "2"]);
        if(visitorId){
          _paq.push(["setVisitorId", visitorId]);
        }

        _paq.push(["setUserId", `${vccCode}@${userNum}`]);

        var d = document,
          g = d.createElement("script"),
          s = d.getElementsByTagName("script")[0];
        g.async = true;
        g.src = u + "matomo.js";
        s.parentNode.insertBefore(g, s);
      })();
    },

    // 1-1、初始化消息提示位置配置
    setAppNotifyPostion() {
      const { notice = {} } = this.userInfo || {};
      if (notice.systemNoticePosition) {
        let postion = "";
        switch (notice.systemNoticePosition) {
          case "bottomLeft":
            postion = "bottom-left";
            break;
          case "bottomRight":
            postion = "bottom-right";
            break;
          case "topLeft":
            postion = "top-left";
            break;
          case "topRight":
            postion = "top-right";
            break;
          default:
            postion = "top-right";
            break;
        }

        notice.systemNoticePosition = postion;
      }

      this._config.APP_NOTIFY = notice;
    },
    // 设置系统图标
    setSysBaseInfo() {
      const {
        vcc: { systemIcon = "", systemName = this.$t('app.defaultSystemName') } = {},
        userId,
        userNum,
        vccId,
        vccCode,
      } = this.userInfo || {};

      this._config.LOGIN_USER = {
        USER_ID: userId,
        USER_NUM: userNum,
        VCC_ID: vccId,
        VCC_CODE: vccCode,
      };

      let title = systemName || this.$t('app.defaultSystemName');
      window.document.title = title;
      ShineObj.init({ titleDefault: title });

      if (!systemIcon) {
        return false;
      }
      let $favicon = document.querySelector('link[rel="icon"]');
      if ($favicon !== null) {
        $favicon.href = systemIcon;
      } else {
        $favicon = document.createElement("link");
        $favicon.rel = "icon";
        $favicon.href = systemIcon;
        document.head.appendChild($favicon);
      }
    },
    /**
     * 2、初始化电话条
     *  以下条件不初始化话
     *  1、大账户
     *  2、企业未开启电话条模块
     *  3、分机号码未获取到
     *  4、开启验证且非呼叫中心用户
     *  5.userWincallShow 为false的时候
     */
    initWincall() {
      const {
        wincall: WINCALL_V2 = {},
        isSuperAdmin = false,
        config: { userOutcallPopup = 1, userInboundPopup = 1, userWincallShow = true },
        vcc: { isEnableCrm = true, phoneBarVersion = 2, isEnableLicenseVerify },
        userType = [],
        userId,
        vccId
      } = this.userInfo || {};

      const wincall_link = this.getWincallUrl();

      // 开启新版crm
      this._config.isEnableCrm = isEnableCrm;
      this._config.USER_OUT_CALL_POPUP = userOutcallPopup;
      this._config.USER_IN_BOUND_POPUP = userInboundPopup;

      if (isEnableCrm) {
        let { my: { crm_page = "" } = {} } = this._config.URL || {};
        this._config.CRM_HOST = crm_page;

        // 有地址在查询弹屏标题配置
        crm_page &&
          getPopTabNameConfig(crm_page).then((resp) => {
            const { code, data } = resp;
            if (code == 200) {
              if (data.customize_tabname) {
                this._config.TAB_NAME_CONFIG = data.customize_tabname;
              }
            }
          });
      }


      if(!userWincallShow){
        console.log("userWincallShow",userWincallShow);
        return false;
      }

      if (isSuperAdmin) {
        console.log(this.$t('app.superAdminNoPhoneBar'));
        return false;
      }

      if (JSON.stringify(WINCALL_V2) == "{}") {
        console.log(this.$t('app.phoneBarNotEnabled'));
        return false;
      }

      if (!WINCALL_V2.phone) {
        if (phoneBarVersion == 5 && WINCALL_V2.webrtc) {
          // 继续向下走
        } else {
          console.log(this.$t('app.noExtNumber'));
          return false;
        }
      }

      if(String(isEnableLicenseVerify) === '1' && !userType.includes('1')) {
        console.log(this.$t('app.notCallCenterUser'));
        // 您当前没有开通呼叫中心的功能，如需使用请联系管理员进行配置
        return false;
      }

      if (wincall_link.wincall_url) {
        let scripts = [
          {
            url: wincall_link.wincall_url + "?" + wincall_link.wincall_hash,
            callBack: () => {
              if (wincall_link.wincall_url.includes("beta")) {
                WINCALL_V2.isBeta = true;
              }
              this._config.WINCALL_VERSION = wincall_link.version;
              const language = this.$i18n.locale || 'zh-CN';
              initWinCallSdk({ ...WINCALL_V2, language, userId, vccId }, wincall_link.version);
            },
          },
        ];

        loadScript(scripts, 0);
      } else {
        console.log(this.$t('app.phoneBarResFailed'));
      }
    },
    /**
     *  获取电话条sdk资源地址信息: version=custom 按照v2逻辑去初始化
     *  返回一个对象{wincall_url,wincall_hash,version:2/custom/3}
     */
    getWincallUrl() {
      const {
        vcc: { phoneBarVersion = 2 },
      } = this.userInfo || {};

      const {
        cc: { wincall = {} } = {},
        custom: { wincall: wincall_custom = {} } = {},
      } = this._config.URL;

      const {
        wincall_url = "",
        wincall_hash = "",
        wincall_v3_url = "",
        wincall_v3_hash = "",
        wincall_v5_url = "",
        wincall_v5_hash = "",
      } = wincall;

      const {
        wincall_url: wincall_url_custom = "",
        wincall_hash: wincall_hash_custom = "",
        wincall_version: wincall_version_custom = "",
      } = wincall_custom;

      if (phoneBarVersion == 3) {
        return {
          wincall_url: wincall_v3_url,
          wincall_hash: wincall_v3_hash,
          version: 3,
        };
      }

      if (phoneBarVersion == 5) {
        if (wincall_url_custom && wincall_version_custom === '2-5') {
          return {
            wincall_url: wincall_url_custom,
            wincall_hash: wincall_hash_custom,
            version: "2-5",
          };
        }
        return {
          wincall_url: wincall_v5_url,
          wincall_hash: wincall_v5_hash,
          version: "2-5",
        };
      }

      if (wincall_url_custom) {
        return {
          wincall_url: wincall_url_custom,
          wincall_hash: wincall_hash_custom,
          version: wincall_version_custom || "custom",
        };
      }

      return {
        wincall_url: wincall_url,
        wincall_hash: wincall_hash,
        version: 2,
      };
    },
    // 3、初始化消息WS
    initMsgSocket() {
      const { websocketUrls: { message: message_url = "" } = {} } =
        this.userInfo || {};

      if (!message_url) {
        console.log(this.$t('app.wsAddressEmpty'));
        return false;
      }

      this.msgSocket = new ReconnectingWebSocket(message_url, null, {
        debug: false,
        reconnectInterval: 3000,
        maxReconnectInterval: 10000,
        maxReconnectAttempts: 100,
      });

      this.msgSocket.onopen = this.socketOpenFn;
      this.msgSocket.onmessage = this.socketMsgFn;
      this.msgSocket.onerror = () => {
        clearInterval(this.heart_monitor_timer);
        console.log("msgSocket error");
      };
      this.msgSocket.onclose = () => {
        clearInterval(this.heart_monitor_timer);
        console.log("msgSocket close");
      };
    },
    // 3-1、WS 连接成功
    socketOpenFn() {
      const { userId } = this.userInfo || {};
      const user_id = userId + "";
      this.socketHeart();
      // 获取离线消息
      this.msgSocket.send(JSON.stringify({ action: "offline", data: user_id }));
    },

    // 3-2、WS 监听消息
    socketMsgFn(message) {
      const lang = this.$i18n.locale || 'zh-CN'
      const { APP_NOTIFY = {}, URL = {} } = this._config;
      const { my: { ekt_common = "",manage_page = '' } = {} } = URL;
      const {
        isEnableNotice = true,
        noticeType = "system",
        systemNoticePosition = "",
        isAutoClose = true,
        autoCloseInterval = 5,
        isEnableStrongNotice = true,
      } = APP_NOTIFY;

      this._config.IS_ENABLE_STRONG_NOTICE = isEnableStrongNotice

      if (!isEnableNotice) {
        console.log(this.$t('app.noSystemNotice'));
        this.updateUnReadMsgCount();
        return false;
      }
      
      let responceMessage = message.data || "";
      if (responceMessage.length > 0) {
        let responce = JSON.parse(responceMessage);
        let sender = "";
        let typeName = this.$t('app.sysMessage');

        switch (responce["type"]) {
          case "message":
            if (responce["reply_user_id"]) {
              // 旧版：包含回复功能按钮
              // sender = responce['sender'] + '【<span class="reply" onclick=beforeMessageClick("' + responce['reply_user_id'] + '","' + "message" + '","' + responce['message_id'] + '")>回复</span>】';
              sender = responce["sender"];
            }

            responce["message"] = (responce["message"] || "").replace(/soundWarnDomain/g, manage_page);
            typeName = this.$t('app.agentMessage', { sender: responce["sender"] });
            break;
          case "remind":
            // 旧版
            // sender = '提醒时间到 【<span class="reply" onclick=beforeMessageClick("' + responce['mark'] + '","' + "remind" + '","' + responce['message_id'] + '")>处理</span>】';
            sender = this.$t('app.remindTime');
            typeName = this.$t('app.remindMessage');
            break;
          case "announce":
            sender = this.$t('app.announceMessage');
            typeName = this.$t('app.announceMessage');
            responce[
              "message"
            ] += `【<a href='#' style='cursor: pointer;' data-mark='${responce["mark"]}' data-msgid='${responce["message_id"]}' onclick='look_announce(this)'>${this.$t('app.viewAnnounce')}<\/a>】`;
            break;
          case "system":
            sender = getContentByLang(responce["title"], lang) || this.$t('app.sysMessage');
            typeName = sender;
            //这里默认为已读
            if (responce["message_id"] != "") {
              this.updateMsgReadStatus(responce["message_id"]);
            }
            break;

          case "common":
            // 通用：跳转指定的页面
            sender = responce["title"] || this.$t('app.passwordExpireRemind');
            typeName = sender;
            //这里默认为已读
            if (responce["message_id"] != "") {
              this.updateMsgReadStatus(responce["message_id"]);
            }
            break;
          case "ticket":
            sender = responce["title"] || this.$t('app.sysMessage');
            typeName = sender;
            //将消息id拼接到message的后面，以hidden input框的形式
            responce[
              "message"
            ] += `<input type='hidden' class='message_id' value='${responce["message_id"]}'/>`;
            break;
          case "error": // 服务器返回错误，则客户端断开连接
            this.msgSocket.close();
            console.warning(
              this.$t('app.wsServerError', { message: responce["message"] })
            );
            return;
          default:
            return;
        }

        if (noticeType == "system") {
          let notifyInstance = null;
          let options = {
            customClass: "sys-notify",
            title: sender,
            dangerouslyUseHTMLString: true,
            message: getContentByLang(responce["message"], lang),
            position: systemNoticePosition,
            duration: 0,
          };
          if (responce.onClick) {
            const { tabOptions: { title = "", url = "" } = {} } =
              responce || {};
            if (url) {
              options.type = "warning";
              options.onClick = (e) => {
                if (responce["message_id"] != "") {
                  this.updateMsgReadStatus(responce["message_id"]);
                }
                if (e.target.className.includes("close-btn")) {
                  notifyInstance.close();
                } else {
                  this.addTab({
                    key: title,
                    name: title,
                    url: url,
                  });
                }
              };

              options.message += `<div style="text-align: right;"><span class="close-btn">${this.$t('app.iKnow')}</span></div>`;
            }
          }
          if (isAutoClose) {
            options.duration = autoCloseInterval * 1000;
          }

          notifyInstance = this._notify(options);
        } else if (noticeType == "browser") {
          let duration = 0;
          if (isAutoClose) {
            duration = autoCloseInterval * 1000;
          }

          this.pushNotice(
            typeName,
            getContentByLang(responce["message"], lang).replace(/<[^>]+>/g, ""),
            ekt_common + "/messageCenter/message",
            isAutoClose - 0,
            this.$t('app.messageCenter'),
            duration
          );
        }

        //弹框之后，再去调用一遍获取未读消息数据的接口
        this.updateUnReadMsgCount();
      }
    },
    /**
     * 开启客户端心跳包
     */
    socketHeart() {
      const heart_packet = { action: "heartbeat", data: "ping" };
      this.heart_monitor_timer = setInterval(() => {
        if (this.msgSocket) {
          this.msgSocket.send(JSON.stringify(heart_packet));
        }
      }, 20000);
    },
    // 推送桌面通知
    pushNotice(title, body, url, auto_close, tab_title, duration = 0) {
      const { vcc: { systemIcon = "" } = {} } = this.userInfo || {};
      let params = {
        body: body,
        icon: systemIcon || this._config.DEFAULT_LOGO,
        requireInteraction: true,
        onClick: () => {
          console.log("pushNotice", "onClick");
          if (url) {
            console.log("pushNotice", "if");
            let addTabItem = {
              key: String(tab_title),
              name: tab_title,
              url: url,
              icon: "",
            };
            console.log(JSON.stringify(addTabItem));
            this.addTab(addTabItem);
          } else {
            console.log("pushNotice", "else");
            window.focus();
            this.close();
          }
        },
      };

      if (parseInt(auto_close)) {
        params.requireInteraction = false;
        params.timeout = duration || 6000;
      }

      if (Push.Permission.has()) {
        Push.create(title, { ...params });
      } else {
        console.log(this.$t('app.noBrowserNotifyPermission'));
      }
    },
    loadWatermark() {
      const {
        userName,
        userNum,
        vcc:{
          ifWatermark,
          vccWatermarkWords
        }
      } = this.userInfo || {};
      const content = vccWatermarkWords || `${userName} ${userNum}`;
      const watermark = new Watermark({
        content: content,
        width: 100,
        height: 60,
        rotate: 30,
        layout: 'grid',
        gridLayoutOptions: {
          rows: 2,
          cols: 2,
          gap: [20, 20],
          matrix: [
            [1, 0],
            [0, 1],
          ],
        },
        advancedStyle: {
          type: 'linear',
          colorStops: [
            {
              offset: 0,
              color: 'rgba(0,0,0,.15)'
            },
            {
              offset: 1,
              color: 'rgba(0,0,0,.15)'
            }
          ]
        },
        onSuccess: () => {
          // success callback
        },
      })

      watermark.create()
      this.watermark = watermark
    }
  },
};
</script>

<style lang="less">
#app-content {
  height: 100%;
  width: 100%;
  overflow: hidden;

  &.only{
    height: auto;
    width: auto;
    min-width: auto !important;
    min-height: 50px;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue